import React from 'react';

export default class Page7 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 2: Scoring the self-analysis
                                                questionnaire
                                            </div>
                                            <p>Now you’ve completed the questionnaire, calculate your score for
                                                each of the 9 areas (that is, the
                                                4 learning styles we described at the beginning plus the 5
                                                personality characteristics of the
                                                ‘Big Five’), in the table below. To do this you need to add your
                                                scores for each set of five questions
                                                relating to each area. For example:</p>
                                            <p>Openness – questions 1, 10, 19, 28 and 37 make up this area. To
                                                calculate your score for
                                                Openness, look at the box you ticked for Q1 (strongly agree to
                                                strongly disagree) and note down
                                                your score for that question (this will be between 1 and 5 and
                                                is shown on the heading for the
                                                table). Now do this for questions 10, 19, 28 and 37 and add them
                                                together. Write the number in
                                                the total column of the table below.</p>
                                            <p>Repeat this process for each area, adding up your scores for the
                                                corresponding questions shown
                                                in the table.
                                            </p>
                                            <div className="mobile-scroll">

                                                <table width="56%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport  tablesrink" style={{width:'100%'}}>
                                                    <tbody>
                                                    <tr>
                                                        <th bgcolor="#fdb83b" align="left" width="20%"
                                                            valign="top">
                                                            <div align="left">Area</div>
                                                        </th>
                                                        <th align="left" width="20%" valign="top">
                                                            <div align="center">Questions to add</div>
                                                        </th>
                                                        <th align="left" width="20%" valign="top">
                                                            <div align="center">Total</div>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen">
                                                            <div align="left">Openness</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">1, 10, 19, 28, 37</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">
                                                                {pageData?.openness}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen">
                                                            <div align="left">Diverging</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">2, 11, 20, 29, 38</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">
                                                                {pageData?.diverging}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen">
                                                            <div align="left">Conscientiousness</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">3, 12, 21, 30, 39</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">
                                                                {pageData?.conscientiousness}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen">
                                                            <div align="left">Assimilating</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">4, 13, 22, 31, 40</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">
                                                                {pageData?.assimilating}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen">
                                                            <div align="left">Extroversion</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">5, 14, 23, 32, 41</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">
                                                                {pageData?.extroversion}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen">
                                                            <div align="left">Converging</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">6, 15, 24, 33, 42</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">
                                                                {pageData?.converging}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen">
                                                            <div align="left">Agreeableness</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">7, 16, 25, 34, 43</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">
                                                                {pageData?.agreeableness}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen">
                                                            <div align="left">Accommodating</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">8, 17, 26, 35, 44</div>
                                                        </td>
                                                        <td className="darkgreen">
                                                            <div align="center">
                                                                {pageData?.accommodating}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen">
                                                            <div align="left">Neuroticism</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">9, 18, 27, 36, 45</div>
                                                        </td>
                                                        <td className="lightgreen">
                                                            <div align="center">
                                                                {pageData?.neuroticism}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="border_subtitle">Step 3: Identify your learning
                                                styles
                                            </div>
                                            <p>Your main personality preference (the Big Five factor you would
                                                most strongly associate with) will
                                                determine your combination of preferred learning styles. Below,
                                                we have matched each personality
                                                preference with the most likely combinations.
                                            </p>
                                            <p>Using the scores you entered into the table above, add each ‘area
                                                combination’ and write your
                                                total in the box for each in the Personality – Learning Styles
                                                Matrix below. For example, if you
                                                score 10 on Openness and 12 on Diverging then enter 22 in the
                                                grid, in the ‘Dreamer’ box.
                                            </p>
                                            <div className="border_subtitle bottomPaddingTable">Personality –
                                                Learning styles matrix:
                                            </div>
                                            <div className="mobile-scroll" style={{height:'auto'}}>

                                                <table cellSpacing="0" cellPadding="0" border="0" width="100%"
                                                       className="ilead_v_sport  tablesrink">
                                                    <tbody>
                                                    <tr>
                                                        <th width="30%" align="left" valign="top"
                                                            className="green_curve greenHeadingbg preference"
                                                            rowSpan="2">Personality Preferences
                                                        </th>
                                                        <th width="70%" align="left" valign="top" colSpan="4"
                                                            className=" green_curve1">Learning Style Combination
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th width="18%" align="center" valign="top"
                                                            className="lightgreen subheading2bg subTableHEading sept"
                                                            style={{textAlign:'center'}}>Diverging
                                                        </th>
                                                        <th width="17%" align="center" valign="top"
                                                            className="lightgreen subheading2bg subTableHEading "
                                                            style={{textAlign:'center !important'}}>Assimilating
                                                        </th>
                                                        <th width="17%" align="center" valign="top"
                                                            className="lightgreen subheading2bg subTableHEading "
                                                            style={{textAlign:'center !important'}}>Converging
                                                        </th>
                                                        <th width="18%" align="center" valign="top"
                                                            className="lightgreen subheading2bg subTableHEading septor"
                                                            style={{textAlign:'center !important'}}>Accommodating
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" className="lightgreen">Openness to
                                                            Experience
                                                        </td>
                                                        <td align="center" className="lightgreen">Dreamer
                                                            <div align="center">{pageData?.learning_style_combination?.dreamer}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Connector
                                                            <div align="center">{pageData?.learning_style_combination?.connector}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Inventor
                                                            <div align="center">{pageData?.learning_style_combination?.inventor}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Puppy
                                                            <div align="center">{pageData?.learning_style_combination?.puppy}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" className="darkgreen"
                                                            strong="">Conscientiousness
                                                        </td>
                                                        <td align="center" className="darkgreen">Analyst
                                                            <div align="center">{pageData?.learning_style_combination?.analyst}</div>
                                                        </td>
                                                        <td align="center" className="darkgreen">List Maker
                                                            <div align="center">{pageData?.learning_style_combination?.list_maker}</div>
                                                        </td>
                                                        <td align="center" className="darkgreen">Piston
                                                            <div align="center">{pageData?.learning_style_combination?.piston}</div>
                                                        </td>
                                                        <td align="center" className="darkgreen">Monitor
                                                            <div align="center">{pageData?.learning_style_combination?.monitor}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" className="lightgreen"
                                                            strong="">Extroversion
                                                        </td>
                                                        <td align="center" className="lightgreen">Socialite
                                                            <div align="center">{pageData?.learning_style_combination?.socialite}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Facilitator
                                                            <div align="center">{pageData?.learning_style_combination?.facilitator}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Co-ordinator
                                                            <div align="center">{pageData?.learning_style_combination?.co_ordinator}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Explorer
                                                            <div align="center">{pageData?.learning_style_combination?.explorer}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" className="darkgreen"
                                                            strong="">Agreeableness
                                                        </td>
                                                        <td align="center" className="darkgreen">Sponge
                                                            <div align="center">{pageData?.learning_style_combination?.sponge}</div>
                                                        </td>
                                                        <td align="center" className="darkgreen">Fluffy Robot
                                                            <div align="center">{pageData?.learning_style_combination?.fluffy_robot}</div>
                                                        </td>
                                                        <td align="center" className="darkgreen">Family
                                                            <div align="center">{pageData?.learning_style_combination?.family}</div>
                                                        </td>
                                                        <td align="center" className="darkgreen">Volunteer
                                                            <div align="center">{pageData?.learning_style_combination?.volunteer}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" className="lightgreen"
                                                            strong="">Neuroticism
                                                        </td>
                                                        <td align="center" className="lightgreen">Jelly
                                                            <div align="center">{pageData?.learning_style_combination?.jelly}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Lawyer
                                                            <div align="center">{pageData?.learning_style_combination?.lawyer}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Rebel
                                                            <div align="center">{pageData?.learning_style_combination?.rebel}</div>
                                                        </td>
                                                        <td align="center" className="lightgreen">Yo-Yo
                                                            <div align="center">{pageData?.learning_style_combination?.yo_yo}</div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <p>So, for example, if you clearly demonstrate extrovert
                                                characteristics; that is, you enjoy being with
                                                people, are energetic, outgoing and open to challenges or new
                                                experiences, your learning styles
                                                combination is likely to be <span
                                                    className="subtiltereg">‘EXPLORER’.</span></p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}